// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__h2aws","head":"Table_head__G30BS","col":"Table_col__34c7u"};